import { render, staticRenderFns } from "./lottery.vue?vue&type=template&id=0d3d8a6a&scoped=true&"
import script from "./lottery.vue?vue&type=script&lang=js&"
export * from "./lottery.vue?vue&type=script&lang=js&"
import style0 from "./lottery.vue?vue&type=style&index=0&id=0d3d8a6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3d8a6a",
  null
  
)

export default component.exports